import React from "react";
import { connect } from "react-redux";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { RouteComponentProps } from "react-router-dom";
import { client } from "../../shared/apiClient";
import Header from "../Common/Header";
import KioskTableRow from "./KioskTableRow";
import {
  IKioskOptionsDto,
  IKioskSessionsDto,
  ISortDto,
  ISentInfoSheet,
  IFailedEmailsList
} from "../../shared/dto/IKioskDto";
import { iRootState } from "../../store";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Theme/custom-toast.css";

// @ts-ignore
import { CWBTable, CWBDropdown, sortArray } from "cwb-react";
// @ts-ignore
import { CWBLoadingCrest } from "cwb-react";
import imageSrc from "../../images/icon-cwb-logo-grey.svg";

import AlertMessage from "../Modals/AlertMessage";
import { IKeyValueVideoDirection } from "../../interfaces/IKeyValueVideoDirection";
import FailedEmailDetailsModal from "../Modals/FailedEmailDetailsModal";
import ResendAuditionLinkModal from "../Modals/ResendAuditionLinkModal";
import { formatTimeOffset} from "../../helpers"
import LocationModal from "../Modals/LocationModal";
const queryString = require("qs");

interface IState {
  options?: IKioskOptionsDto[];
  selectedOption?: IKioskOptionsDto;
  isLoading: boolean;
}

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  history: any;
}

class Kiosk extends React.Component<IProps, IState> {
  public state: IState = {
    options: [
      { label: this.props.t("Today's"), value: "today" },
      { label: this.props.t("All"), value: "all" },
      { label: this.props.t("Recent"), value: "recent" },
    ],
    selectedOption: {} as IKioskOptionsDto,
    isLoading: false
  };

  async componentWillMount() {
    try {
      this.handleExternal();

      this.setState({
        isLoading: true,
      });

      let selectedOption = this.getFilter() || this.props.selectedKioskOption;

      if (!selectedOption || !selectedOption.value)
        selectedOption = this.state.options.find((x) => x.value === "today");

      await this.props.setSelectedKioskOption(selectedOption);
      this.setState({ selectedOption: selectedOption });

      await this.props.getKioskSessions(selectedOption.value);

      if (this.props.sessions.length > 0) {
        const sessionIds = this.props.sessions.map((x) => x.scheduleId);
        await this.props.getSentAuditionInfoSheet(sessionIds);
      }

      this.setState({ isLoading: false });
    } catch (error) {
      this.props.history.push("/500");
    }
  }

  componentDidMount() {
    this.showToastInfoSheet();
  }

  handleExternal = () => {
    const { match, t } = this.props;
    if (!match || !this.isVcrCreated(match.params)) return;

    toast.success(t("Virtual Audition room created"), {
      position: "top-right",
    });
    this.sendActorZoomEmailInvitation(match.params);
  };

  isVcrCreated = (params: any) => {
    return params && params.created && params.created === "created";
  };

  getFilter = () => {
    const qsArgs = decodeURI(window.location.search).split("?")[1];
    const result = queryString.parse(qsArgs);
    if (!result || !result.filter) return;
    const { options } = this.state;
    return options.find((x) => x.value === result.filter);
  };

  sendActorZoomEmailInvitation = async (params: any) => {
    const { t, setShowFailedEmailModal } = this.props;

    if (params && params.scheduleId && params.scheduleId > 0) {
      const success = await this.props.sendZoomEmail(params.scheduleId);
      if (success) {
        toast.success(t("Virtual Audition Link / Location sent successfully"), {
          position: "top-right"
        });
      } else if (success === false) {
        toast.error((
          <span>
            {t("Some attendees did not receive the audition information (Virtual Audition Link / Location).")}
            &nbsp;
            <StyledButton
              onClick={() => setShowFailedEmailModal(true)}
            >
              {t("view details")}
            </StyledButton>
          </span>
        ), {
          position: "top-right",
          autoClose: false
        });
      }
    }
  };

  showToastInfoSheet = () => {
    const { location } = this.props;
    if (!location || !location.state) return;
    const state: any = location.state;
    if (state.infoSheetToast === "saved") {
      toast.success("Info Sheet saved!", {
        position: "top-right",
      });
    }
  };

  onFilterChange = async (option: any) => {
    await this.props.setSelectedKioskOption(option);
    await this.props.getKioskSessions(option.value);
    const sessionIds = this.props.sessions.map((x) => x.scheduleId);
    if (sessionIds.length) {
      await this.props.getSentAuditionInfoSheet(sessionIds);
    }
    this.setState({ selectedOption: option });
    this.props.history.push({
      pathname: this.props.history.pathname,
      search: '?filter=' + option.value
    })

  };
 
  render() {
    const { t, history, sentInfoSheets } = this.props;
    let { sessions } = this.props;

    const breadCrumbList = [
      {
        label: t("Scheduling"),
        to: `${client.api.paths.domain}/castingworkbook/directors/schedulelist.asp`,
      },
      { label: t("Casting Kiosk") },
    ];

    let headers = [
      { label: t("Audition Date"), field: "auditionDate" },
      { label: t("Project") },
      { label: (t("Virtual Audition Link") + " / " + t("Location")) },
      { label: t("Video Directions") },
      { label: t("Info sheet") },
      { label: t("Session Details") },
    ];

    sessions = sortArray(sessions.map((session: IKioskSessionsDto) => {
      const match = sentInfoSheets.find((s: any) => {
        return s.scheduleId === session.scheduleId;
      });

      return match ? {
        ...session,
        hasSentInfoSheet: match.hasSent
      } : session;
    }), [{
      field: this.props.sortField,
      desc: this.props.sortDescending
    }]);

    return (
      <Wrapper>
        {/* <p>
          <PlayerContainer />
        </p> */}
        {/* <ToastContainer
          hideProgressBar={true}
          toastClassName="toaster--success"
          bodyClassName="toaster-body toaster__icon--success"
          autoClose={2000}
        /> */}
        <AlertMessage {...this.props} />
        {this.props.showFailedEmailModal && (
          <FailedEmailDetailsModal
            failedEmailsList={this.props.failedEmailsList}
            showModal={this.props.showFailedEmailModal}
            togglePopover={() => this.props.setShowFailedEmailModal(false)}
          />
        )}
        {this.props.showResendLinkModal && (
          <ResendAuditionLinkModal />
        )}
        {this.props.showLocationEnabledModal && (
          <LocationModal />
        )}
        <Header
          title={t("Casting Kiosk")}
          breadCrumbList={breadCrumbList}
        >
          <LeftText
            style={{ cursor: "pointer" }}
            onClick={() => history.push(`/kioskManagement`)}
          >
            <i className="icon-cwb-settings"></i>
            {t("Kiosk Management")}
          </LeftText>
        </Header>
        <ContentBox>
          <ContentHeader>
            <ContentTitle>{t("Sessions")}
              {this.props.authenticatedUser.utcOffset && (<div style={{marginTop:"-5px"}}><small>UTC{formatTimeOffset(this.props.authenticatedUser.utcOffset)} ({this.props.authenticatedUser.cityName})</small></div>)}
            </ContentTitle>
            <StyledDropdown
              placeholder={t("Select")}
              items={this.state.options}
              value={this.state.selectedOption}
              onChange={(option: any) => this.onFilterChange(option)}
            />
          </ContentHeader>
          {this.state.isLoading ? (
            <CWBLoadingCrest customLogoSrc={imageSrc} />
          ) : (
              <StyledTable
                rowComponent={KioskTableRow}
                rows={sessions}
                headers={headers}
                sortField={this.props.sortField}
                sortDescending={this.props.sortDescending}
                onSortChanged={this.props.setSortFieldDescending}
              />
            )}
        </ContentBox>
      </Wrapper>
    );
  }
}

interface StateProps {
  sessions: IKioskSessionsDto[];

  sentInfoSheets: ISentInfoSheet[];
  sortField: string;
  sortDescending: string;
  selectedKioskOption: IKioskOptionsDto;
  dictVideoDirection: IKeyValueVideoDirection;
  failedEmailsList: IFailedEmailsList[];
  showFailedEmailModal: boolean;
  showResendLinkModal: boolean;
  authenticatedUser: any;
  showLocationEnabledModal : boolean;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    sessions: state.kiosk.sessions,
    sentInfoSheets: state.kiosk.sentInfoSheets,
    sortField: state.kiosk.sortField,
    sortDescending: state.kiosk.sortDescending,
    selectedKioskOption: state.kiosk.selectedKioskOption,
    dictVideoDirection: state.kiosk.dictVideoDirection,
    failedEmailsList: state.kiosk.failedEmailsList,
    showFailedEmailModal: state.kiosk.showFailedEmailModal,
    showResendLinkModal: state.kiosk.showResendLinkModal && state.kiosk.showResendLinkModal.show,
    showLocationEnabledModal: state.kiosk.showLocationEnabledModal && state.kiosk.showLocationEnabledModal.show,
    authenticatedUser: state.app.authenticatedUser
  };
}

interface DispatchProps {
  getKioskSessions: (option: string) => void;
  getSentAuditionInfoSheet: (ids: number[]) => void;
  setSortFieldDescending: ({ sortField, sortDescending }: ISortDto) => void;
  setSelectedKioskOption: (selectedOption: IKioskOptionsDto) => void;
  sendZoomEmail: (id: string) => boolean;
  setShowFailedEmailModal: (showFailedEmailModal: boolean) => any;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getKioskSessions: dispatch.kiosk.getKioskSessions,
    getSentAuditionInfoSheet: dispatch.kiosk.getSentAuditionInfoSheet,
    setSortFieldDescending: dispatch.kiosk.setSortFieldDescending,
    setSelectedKioskOption: dispatch.kiosk.setSelectedKioskOption,
    sendZoomEmail: dispatch.kiosk.sendZoomEmail,
    setShowFailedEmailModal: dispatch.kiosk.setShowFailedEmailModal
  };
}

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Kiosk));

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${(p) => p.theme.kiosk.backgroundColor};

  .cwb-table-wrapper {
    max-width: 1040px;
    border: 1px solid #e7e7f0 !important;
    box-shadow: 0 2px 4px 0 #e0e0e0 !important;
    border-radius: 4px;
  }
`;

const LeftText = styled.a`
  &&&,
  &.hover {
    color: ${(p) => p.theme.grey};
    font-size: ${(p) => p.theme["xs-font-size"]};
    font-weight: ${(p) => p.theme["font-weight-600"]};
    line-height: 18px;
    i {
      position: relative;
      right: 6px;
      top: 1px;
      text-decoration: none !important;
    }
  }
`;

const ContentBox = styled.div`
  width: 100%;
  min-height: 70vh;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  padding: ${(p) => p.theme.spacing(0, 6)};
  overflow-x: auto;
  overflow-y: hidden;

  & div.cwb-table-wrapper {
    max-width: 1440px;
  }
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  margin-right: 2px;
`;

const ContentTitle = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
`;

const StyledTable = styled(CWBTable)`
  background: white;
  box-shadow: none !important;

  thead {
    border-radius: 3px 3px 0 0;
    box-shadow: inset 0 -1px 0 0 #e7e7f0;

    tr {
      border: 0;
      th {
        height: 50px;
        background-color: #f8f8f8;
        > div {
          color: ${(p) => p.theme.grey};
          font-size: ${(p) => p.theme["s-font-size"]};
          font-weight: ${(p) => p.theme["font-weight-600"]};
          text-transform: initial;
          line-height: 19px;
        }
        &:first-child {
          padding-left: 24px;
        }
        // &:nth-child(3) {
        //   width: 80%;
        // }
        .icon-cwb-chevron:before {
          color: ${(p) => p.theme.grey} !important;
        }
      }
      td {
        text-overflow: ellipsis;
      }
    }
  }
`;

const StyledDropdown = styled(CWBDropdown)`
  min-width: 120px !important;
  max-width: 120px !important;

  .cwb-dropdown__control {
    height: 40px;
    min-height: 40px !important;
  }
  .cwb-dropdown__menu {
    margin-top: 4px;
  }
  .cwb-dropdown__indicator,
  .cwb-dropdown__indicator:hover {
    width: 14px !important;
    color: ${(p) => p.theme.grey} !important;
  }
`;

const StyledButton = styled.button`
  color: #0F9BF0;
  padding: 0;
  background-color: #FFF;
  border: none;
  text-decoration: underline;
`;
